<template>
  <div class="matrix-chart"></div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'CustomerAnalysisMatrix',
  props: {
    dataList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    dataList: {
      deep: true,
      handler() {
        this.setOption()
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.chart = echarts.init(this.$el)
      this.chart.on('click', params => {
        if (params.data && params.data.customerId) {
          this.$emit('select', params.data.customerId)
        }
      })
      window.addEventListener('resize', this.resize)
      this.setOption()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },
  methods: {
    resize() {
      if (this.chart) this.chart.resize()
    },
    setOption() {
      if (!this.chart) return
      const seriesData = (this.dataList || []).map(item => ({
        value: [Number(item.valueScore || 0), Number(item.healthScore || 0), Number(item.growthScore || 0)],
        customerId: item.customerId,
        customerName: item.customerName,
        segmentName: item.segmentName,
        riskLevel: item.riskLevel,
        itemStyle: {
          color: item.riskLevel === 'HIGH' ? '#f56c6c' : item.segmentCode === 'GROWTH' ? '#e6a23c' : '#409eff'
        }
      }))
      this.chart.setOption({
        grid: { left: 48, right: 24, top: 28, bottom: 48 },
        tooltip: {
          formatter(params) {
            const value = params.data.value || []
            return `${params.data.customerName}<br/>${params.data.segmentName}<br/>价值 ${value[0]} / 健康 ${value[1]} / 潜力 ${value[2]}`
          }
        },
        xAxis: {
          name: '客户价值',
          min: 0,
          max: 100,
          splitNumber: 4,
          axisLine: { lineStyle: { color: '#909399' } },
          splitLine: { lineStyle: { type: 'dashed', color: '#ebeef5' } }
        },
        yAxis: {
          name: '健康度',
          min: 0,
          max: 100,
          splitNumber: 4,
          axisLine: { lineStyle: { color: '#909399' } },
          splitLine: { lineStyle: { type: 'dashed', color: '#ebeef5' } }
        },
        series: [{
          type: 'scatter',
          data: seriesData,
          symbolSize(data) {
            return 10 + Math.round(Number(data[2] || 0) / 5)
          },
          emphasis: { itemStyle: { shadowBlur: 10, shadowColor: 'rgba(0,0,0,.25)' } },
          markLine: {
            silent: true,
            symbol: 'none',
            lineStyle: { color: '#c0c4cc', type: 'solid' },
            data: [{ xAxis: 60 }, { yAxis: 60 }]
          }
        }]
      }, true)
    }
  }
}
</script>

<style scoped>
.matrix-chart {
  width: 100%;
  height: 360px;
}
</style>
